import * as React from 'react';
import Slider, {
  SliderThumb,
  SliderValueLabelProps,
} from '@mui/material/Slider';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { local } from 'd3';
export const AirbnbSlider = styled(Slider)(({ theme }) => ({
  color: '#6C2AD2',
  '& .MuiSlider-thumb': {
    height: 27,
    width: 27,
    backgroundColor: '#FFFFFF',
    border: '1px solid #E7E5E5',
    '&:hover': {
      boxShadow: '0px 1px 8px rgba(0, 0, 0, 0.15)',
    },
    '& .MuiSlider-valueLabel': {
      fontSize: 14,
      fontFamily: 'Poppins',
      fontWeight: '500',
      top: 55,
      backgroundColor: 'unset',
      color: theme.palette.text.primary,
      '&:before': {
        display: 'none',
      },
      '& *': {
        background: 'transparent',
        color: theme.palette.mode === 'dark' ? '#666666' : '#666666',
      },
    },
    '& .airbnb-bar': {
      height: 13,
      width: 1,
      backgroundColor: '#6C2AD2',
      marginLeft: 1.4,
      marginRight: 1.4,
    },
  },
  '& .MuiSlider-track': {
    height: 12,
  },
  '& .MuiSlider-rail': {
    color: theme.palette.mode === 'dark' ? '#6C2AD2' : '#FFFFFF',
    opacity: theme.palette.mode === 'dark' ? undefined : 1,
    height: 15,
    border: '1px solid #E7E5E5',
    borderRadius: '5px',
  },
}));

export function AirbnbThumbComponent(props) {
  const { children, ...other } = props;
  return (
    <SliderThumb {...other}>
      {children}
      <span className="airbnb-bar" />
      <span className="airbnb-bar" />
      <span className="airbnb-bar" />
    </SliderThumb>
  );
}

export const AirbnbSliderTwo = styled(Slider)(({ theme }) => ({
  color: '#1976d2',
  height: 3,
  padding: '13px 0',
  '& .MuiSlider-thumb': {
    height: 27,
    width: 27,
    backgroundColor: '',
    border: '1px solid currentColor',
    '&:hover': {
      boxShadow: '0 0 0 8px rgba(58, 133, 137, 0.16)',
    },
    '& .airbnb-bar': {
      height: 9,
      width: 1,
      backgroundColor: 'currentColor',
      marginLeft: 1,
      marginRight: 1,
    },
  },
  '& .MuiSlider-track': {
    height: 3,
  },
  '& .MuiSlider-rail': {
    color: theme.palette.mode === 'dark' ? '#bfbfbf' : '#d8d8d8',
    opacity: theme.palette.mode === 'dark' ? undefined : 1,
    height: 3,
  },
}));
export default function CustomizedSlider() {
  const [value, setValue] = React.useState([20000000, 30000000]);
  const handleChange = (event, newValue) => {
    setValue(newValue);
    localStorage.setItem('legalsliderval', newValue);
  };
  return (
    <Box sx={{ width: 1109 }}>
      <Box sx={{ m: 3 }} />
      {/* <Slider
        getAriaLabel={() => 'Temperature'}
        orientation="vertical"
        getAriaValueText={valuetext}
        defaultValue={[20, 37]}
        valueLabelDisplay="auto"
        marks={marks}
      /> */}
      <AirbnbSlider
        slots={{ thumb: AirbnbThumbComponent }}
        // getAriaLabel={(index) => (index === 132342555 ? 'Minimum price' : 'Maximum price')}
        defaultValue={value}
        // onChange={(event)=> {
        //   event.target.value
        // }
        // }
        min={0}
        max={60000000}
        valueLabelDisplay="on"
        onChangeCommitted={handleChange}
        // marks={marks}
      />
    </Box>
  );
}
